import { useEffect, useRef, useState } from 'react';

import type { AplusLayoutDefaultProps } from '../../Layouts/types';
import type { APlusItems } from '../../types';

import { getInitialAplusData } from '../../helper/getInitialAplusData';

export const useAplusData = (
  items: APlusItems,
  onChangeHandler: AplusLayoutDefaultProps['onChangeHandler'],
  triggerOnChangeHandlerOnInit?: AplusLayoutDefaultProps['triggerOnChangeHandlerOnInit'],
) => {
  const [aplusData, setAplusData] = useState(() => getInitialAplusData(items));
  const initialTrigger = useRef(!!triggerOnChangeHandlerOnInit);

  useEffect(() => {
    if (initialTrigger.current) {
      onChangeHandler(aplusData);
      initialTrigger.current = false;
    }
  }, [onChangeHandler, aplusData]);

  const handleItemChange = (uuid: string) => {
    const newAplusData = new Map(aplusData);
    const itemData = newAplusData.get(uuid);
    if (itemData) {
      newAplusData.set(uuid, { ...itemData, selected: !itemData.selected });
      setAplusData(newAplusData);
      onChangeHandler(newAplusData);
    }
  };

  const handleCountChange = (uuid: string, count: number) => {
    const newAplusData = new Map(aplusData);
    const itemData = newAplusData.get(uuid);
    if (itemData) {
      newAplusData.set(uuid, { ...itemData, value: count });
      setAplusData(newAplusData);
      onChangeHandler(newAplusData);
    }
  };

  return {
    aplusData,
    handleItemChange,
    handleCountChange,
  };
};
